import { render, staticRenderFns } from "./LeadBoardDealQuestionnaire.vue?vue&type=template&id=2b87b8fa&"
import script from "./LeadBoardDealQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports